// extracted by mini-css-extract-plugin
export default {"itemData":"itemData---_I_k2"};